<template>
<div class="code-wrapper">
  <transition name="imageCode" mode="out-in">
    <div v-if="codeVisible" class="check-code__container">
      <div class="check-code__title">验证码</div>
      <form class="check-code__form" @submit="e => e.preventDefault()">
        <div class="form-row">
          <input v-model="imageCode" class="check-code__input" placeholder="请输入验证码"/>
        </div>
        <div class="form-row">
          <div :style="'background-image: ' + 'url(' + checkCodeUrl + ');'"class="check-code__img"></div>
          <div @click="_changeCheckCodeImg" class="btn check-code__change">换一张</div>
          <div class="error-msg">{{errorMsg}}</div>
        </div>
        <div class="form-row">
          <div @click="close" class="btn btn-cancel">取消</div>
          <div type="button" @click="_confirmCheckCode"  class="btn btn-confirm">确认</div>
        </div>            
      </form>
    </div> 
  </transition>
</div>
</template>
<script>
  import api from '@/api'
  const pathPrefix = '/xmcaptcha-service'
  export default {
    data () {
      return {
        errorMsg: '',
        checkCodeUrl: '',
        imageCode: ''
      }
    },
    computed: {
      codeVisible () {
        return this.$store.state.imageCodeVisible
      },
      imageCodeURL () {
        return this.$store.state.imageCodeURL
      },
      token () {
        return this.$store.state.imageCodeToken
      },
      captchaInfo () {
        return this.$store.state.captchaInfo
      }
    },
    watch: {
      imageCodeURL (val) {
        this.checkCodeUrl = val
      },
      codeVisible (v) {
        if (!v) {
          this.resetForm()
        }
      }
    },
    methods: {
      resetForm () {
        this.imageCode = ''
        this.errorMsg = ''
      },
      _changeCheckCodeImg () {
        this.checkCodeUrl = this.imageCodeURL + '?ts=' + Date.now()
      },
      _confirmCheckCode () {
        const token = this.token
        const checkCode = this.imageCode.trim()
        if (!checkCode) {
          return this.errorMsg = '验证码不能为空'
        }
        api.checkImageCode({
          token,
          checkCode
        }).then(res => {
          const { ret, msg } = res.data
          if (ret == 0) {
            this.$store.commit('hideImageCode')
            this.errorMsg = ''
          } else {
            this.imageCode = ''
            this.errorMsg = msg
            this.setImageCodeInfo()
          }
        })
      },
      setImageCodeInfo () {
        api.getImageCodeInfo({ info: this.captchaInfo }).then(res => {
          const { background, token } = res.data
          this.$store.commit('setImageCodeURL', pathPrefix + background)
          this.$store.commit('setImageCodeToken', token)
        })
      },
      close () {
        this.$store.commit('hideImageCode')
      }
    }
  }
</script>
<style scoped lang="scss">
.bind-enter-active,
.bind-leave-active {
  transition: all .6s ease;
}
.bind-enter,
.bind-leave-to {
  transform: translate3d(-50%, 50%, 0);
  opacity: 0;
}
.check-code__container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px 40px 20px 40px;
  background: #fff;
  border-radius: 6px;
  .form-row {
    position: relative;
    margin-bottom: 20px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .error-msg {
      position: absolute;
      top: 100%;
      left: 0;
      font-size: 14px;
      color: #fc0d1c;
    }
  }
  .btn {
    display: inline-block;
    padding: 10px 0;
    height: 45px;
    text-align: center;
    font-size: 18px;
    line-height: 1.39;
    box-sizing: border-box;
    cursor: pointer;
  }
  .btn-cancel {
    width: 115px;
    margin-right: 20px;
    border: 1px solid #E1E1E1;
    border-radius: 4px;
    color: #666666;
  }
  .btn-confirm {
    width: 115px;
    background-image: linear-gradient(-90deg, #FF9973 1%, #F86442 95%);
    border-radius: 4px;
    color: #FFFFFF;
  }
}
.check-code__title {
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  letter-spacing: 1.5px;
}

.check-code__input {
  display: block;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 18px;
  line-height: 1.39;
  border: 1px solid #E1E1E1;
  border-radius: 4px;
  &::-webkit-input-placeholder {
    font-size: 18px;
  }
}

.check-code__img {
  display: inline-block;
  margin-right: 20px;
  width: 136px;
  height: 45px;
  vertical-align: middle;
  border: 1px solid #E1E1E1;
  border-radius: 4px;
  background: {
    size: 100%;
    position: center center;
  }
}

.check-code__change {
  width: 94px;
  vertical-align: middle;
  border: 1px solid #F86442;
  border-radius: 4px;
  color: #F86442;
}
</style>


// WEBPACK FOOTER //
// src/components/pop-imageCode.vue